<template>
  <div
    class="bg-white rounded-2xl shadow-xs border border-gray-100 px-5 py-3 flex flex-col md:flex-row md:items-center gap-3 md:gap-5"
  >
    <div class="flex items-center gap-3">
      <div class="shrink-0 rounded-xl bg-purple-100 p-2.5">
        <OfficeBuildingIcon class="h-5 w-5 text-purple-600" />
      </div>

      <div class="flex items-center gap-1.5 shrink-0">
        <span class="truncate text-sm font-medium text-gray-500">{{ t("label") }}</span>
        <VTooltip theme="info-tooltip">
          <InformationCircleIcon class="cursor-pointer h-5 w-4 text-gray-400" aria-hidden="true" />
          <template #popper>
            <span>{{ t("tooltip") }}</span>
          </template>
        </VTooltip>
      </div>

      <span class="text-sm font-bold text-green-600 shrink-0">
        {{ formattedRate }}
      </span>
    </div>

    <div class="flex items-center gap-3 md:gap-5 flex-1">
      <ProgressionBar class="flex-1" :max="data.totalCount" :value="data.activeCount" size="h-3" />

      <div class="shrink-0 whitespace-nowrap">
        <span class="text-2xl md:text-3xl font-extrabold text-gray-900">{{ data.activeCount }}</span>
        <span class="text-sm text-gray-400 ml-0.5">/ {{ data.totalCount }}</span>
      </div>

      <span
        v-if="storeCountDiff != null"
        class="shrink-0 text-xs font-semibold p-2 rounded-full whitespace-nowrap"
        :class="{
          'text-green-600 bg-green-50': storeCountDiff > 0,
          'text-red-600 bg-red-50': storeCountDiff < 0,
          'text-gray-500 bg-gray-50': storeCountDiff === 0,
        }"
      >
        {{ storeCountDiffLabel }}
      </span>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { InformationCircleIcon, OfficeBuildingIcon } from "@heroicons/vue/outline";
import { formatPercentage, ProgressionBar } from "@estaly/ui";

export default {
  components: { InformationCircleIcon, OfficeBuildingIcon, ProgressionBar },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  computed: {
    formattedRate() {
      return formatPercentage(this.data?.current);
    },

    storeCountDiff() {
      if (this.data?.previousActiveCount == null) return null;
      return this.data.activeCount - this.data.previousActiveCount;
    },

    storeCountDiffLabel() {
      const sign = this.storeCountDiff > 0 ? "+" : "";
      return `${sign}${this.storeCountDiff}`;
    },
  },
};
</script>

<i18n src="./ActiveStoresRateCard.i18n.json"></i18n>
